import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { Address } from '@lukso/controllerapps-sharedlogic-primitives'

const ControllerAddressPropsSchema = z.object({
  controllerAddressValue: z.instanceof(Address),
})

type ControllerAddressProps = z.infer<typeof ControllerAddressPropsSchema>

export class ControllerAddress extends ValueObject<ControllerAddressProps> {
  public getValue(): Address {
    return this.props.controllerAddressValue
  }

  /**
   * @returns A 0x-prefixed checksum-based hex string of the address.
   */
  public getChecksumValue(): string {
    return this.props.controllerAddressValue.getChecksumValue()
  }

  public equals(other: ControllerAddress): boolean {
    return this.getChecksumValue() === other.getChecksumValue()
  }

  public static create(props: ControllerAddressProps): ControllerAddress {
    const validatedProps = ControllerAddressPropsSchema.parse(props)
    return new ControllerAddress(validatedProps)
  }
}
